import { cn } from "@/lib/utils";
import { SCORE_SCALE } from "@/constants/forms";

const COLOR_CLASSES = {
  blue: {
    active: "bg-blue-700 border-blue-600 text-white shadow-md shadow-blue-900/30",
    inactive: "bg-blue-700/30 border-blue-700/40 text-blue-200/70 hover:bg-blue-700/50",
  },
  gold: {
    active: "bg-yellow-700 border-yellow-600 text-white shadow-md shadow-yellow-900/30",
    inactive: "bg-yellow-700/30 border-yellow-700/40 text-yellow-200/70 hover:bg-yellow-700/50",
  },
  green: {
    active: "bg-emerald-600 border-emerald-500 text-white shadow-md shadow-emerald-900/30",
    inactive: "bg-emerald-600/30 border-emerald-600/40 text-emerald-200/70 hover:bg-emerald-600/50",
  },
} as const;

interface ScoreSelectorProps {
  label: string;
  hint: string;
  value: number;
  color: keyof typeof COLOR_CLASSES;
  disabled?: boolean;
  onChange: (value: number) => void;
}

export function ScoreSelector({
  label,
  hint,
  value,
  color,
  disabled,
  onChange,
}: ScoreSelectorProps) {
  const palette = COLOR_CLASSES[color];

  return (
    <div className="flex flex-col gap-2">
      <div>
        <p className="text-sm font-semibold text-white">{label}</p>
        <p className="text-xs text-muted-foreground">{hint}</p>
      </div>
      <div className="flex flex-col gap-1.5">
        {SCORE_SCALE.map((score) => {
          const isActive = value === score.value;
          return (
            <button
              key={score.value}
              type="button"
              disabled={disabled}
              onClick={() => onChange(score.value)}
              className={cn(
                "w-full rounded-md border px-3 py-2.5 text-left text-sm font-semibold transition disabled:opacity-60",
                isActive ? palette.active : palette.inactive
              )}
            >
              {score.value} {score.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
